import * as libCrypto from '@ownerone/lib-crypto';

import { decryptFile, encryptFile } from './files';
import { AsymmetricEncryption, KeyPair } from './types';

interface ICryptoCore {
  asymmetric: AsymmetricEncryption;
}

export class CryptoCore implements ICryptoCore {
  public static aes = libCrypto.aes;
  public static files = {
    decrypt: decryptFile,
    encrypt: encryptFile,
  };
  public readonly asymmetric: AsymmetricEncryption;

  constructor() {
    this.asymmetric = libCrypto.ecies;
  }

  public static encryptMnemonic(mnemonic: string, password: string): string {
    return CryptoCore.aes.encrypt(mnemonic, password);
  }

  public static decryptMnemonic(mnemonic: string, password: string): string {
    return CryptoCore.aes.decrypt(mnemonic, password);
  }

  public async mnemonicToKeyPair(mnemonic: string): Promise<KeyPair> {
    return await this.asymmetric.mnemonicToKeyPair(mnemonic);
  }
}
